import { render, staticRenderFns } from "./TrendsChartCard.vue?vue&type=template&id=5d9d2851&scoped=true&"
import script from "./TrendsChartCard.vue?vue&type=script&lang=js&"
export * from "./TrendsChartCard.vue?vue&type=script&lang=js&"
import style0 from "./TrendsChartCard.vue?vue&type=style&index=0&id=5d9d2851&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d2851",
  null
  
)

export default component.exports